import { render } from "./AdminEditProfile.vue?vue&type=template&id=2aba60ec&scoped=true"
import script from "./AdminEditProfile.vue?vue&type=script&lang=js"
export * from "./AdminEditProfile.vue?vue&type=script&lang=js"

import "./AdminEditProfile.vue?vue&type=style&index=0&id=2aba60ec&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aba60ec"]])

export default __exports__